import useSWR from 'swr'

/**
 * 開催回取得Hook
 */
export function useHeldTimes() {

    const fetchAddress = `/competition/api/management/registeredDisplayItem`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`HeldTimes`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 開催回データ
         */
        heldTimes: data,

        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}